/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { VendorErrorCategory } from './VendorErrorCategory';
import {
    VendorErrorCategoryFromJSON,
    VendorErrorCategoryFromJSONTyped,
    VendorErrorCategoryToJSON,
    VendorErrorCategoryToJSONTyped,
} from './VendorErrorCategory';
import type { VendorErrorParameter } from './VendorErrorParameter';
import {
    VendorErrorParameterFromJSON,
    VendorErrorParameterFromJSONTyped,
    VendorErrorParameterToJSON,
    VendorErrorParameterToJSONTyped,
} from './VendorErrorParameter';
import type { VendorErrorState } from './VendorErrorState';
import {
    VendorErrorStateFromJSON,
    VendorErrorStateFromJSONTyped,
    VendorErrorStateToJSON,
    VendorErrorStateToJSONTyped,
} from './VendorErrorState';
import type { VendorErrorImpactedComponent } from './VendorErrorImpactedComponent';
import {
    VendorErrorImpactedComponentFromJSON,
    VendorErrorImpactedComponentFromJSONTyped,
    VendorErrorImpactedComponentToJSON,
    VendorErrorImpactedComponentToJSONTyped,
} from './VendorErrorImpactedComponent';
import type { VendorErrorSeverity } from './VendorErrorSeverity';
import {
    VendorErrorSeverityFromJSON,
    VendorErrorSeverityFromJSONTyped,
    VendorErrorSeverityToJSON,
    VendorErrorSeverityToJSONTyped,
} from './VendorErrorSeverity';

/**
 * 
 * @export
 * @interface UpdateVendorErrorCodeRequestDto
 */
export interface UpdateVendorErrorCodeRequestDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateVendorErrorCodeRequestDto
     */
    manufacturerId?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateVendorErrorCodeRequestDto
     */
    assetTypeId?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateVendorErrorCodeRequestDto
     */
    errorCode?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateVendorErrorCodeRequestDto
     */
    matchType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateVendorErrorCodeRequestDto
     */
    matchKey?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateVendorErrorCodeRequestDto
     */
    vendorErrorCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateVendorErrorCodeRequestDto
     */
    info?: string | null;
    /**
     * 
     * @type {VendorErrorParameter}
     * @memberof UpdateVendorErrorCodeRequestDto
     */
    parameter?: VendorErrorParameter | null;
    /**
     * 
     * @type {VendorErrorState}
     * @memberof UpdateVendorErrorCodeRequestDto
     */
    state?: VendorErrorState | null;
    /**
     * 
     * @type {VendorErrorImpactedComponent}
     * @memberof UpdateVendorErrorCodeRequestDto
     */
    impactedComponent?: VendorErrorImpactedComponent | null;
    /**
     * 
     * @type {VendorErrorCategory}
     * @memberof UpdateVendorErrorCodeRequestDto
     */
    category?: VendorErrorCategory | null;
    /**
     * 
     * @type {VendorErrorSeverity}
     * @memberof UpdateVendorErrorCodeRequestDto
     */
    severity?: VendorErrorSeverity | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateVendorErrorCodeRequestDto
     */
    firmwareVersion?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateVendorErrorCodeRequestDto
     */
    description?: string | null;
}



/**
 * Check if a given object implements the UpdateVendorErrorCodeRequestDto interface.
 */
export function instanceOfUpdateVendorErrorCodeRequestDto(value: object): value is UpdateVendorErrorCodeRequestDto {
    return true;
}

export function UpdateVendorErrorCodeRequestDtoFromJSON(json: any): UpdateVendorErrorCodeRequestDto {
    return UpdateVendorErrorCodeRequestDtoFromJSONTyped(json, false);
}

export function UpdateVendorErrorCodeRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateVendorErrorCodeRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'manufacturerId': json['manufacturerId'] == null ? undefined : json['manufacturerId'],
        'assetTypeId': json['assetTypeId'] == null ? undefined : json['assetTypeId'],
        'errorCode': json['errorCode'] == null ? undefined : json['errorCode'],
        'matchType': json['matchType'] == null ? undefined : json['matchType'],
        'matchKey': json['matchKey'] == null ? undefined : json['matchKey'],
        'vendorErrorCode': json['vendorErrorCode'] == null ? undefined : json['vendorErrorCode'],
        'info': json['info'] == null ? undefined : json['info'],
        'parameter': json['parameter'] == null ? undefined : VendorErrorParameterFromJSON(json['parameter']),
        'state': json['state'] == null ? undefined : VendorErrorStateFromJSON(json['state']),
        'impactedComponent': json['impactedComponent'] == null ? undefined : VendorErrorImpactedComponentFromJSON(json['impactedComponent']),
        'category': json['category'] == null ? undefined : VendorErrorCategoryFromJSON(json['category']),
        'severity': json['severity'] == null ? undefined : VendorErrorSeverityFromJSON(json['severity']),
        'firmwareVersion': json['firmwareVersion'] == null ? undefined : json['firmwareVersion'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function UpdateVendorErrorCodeRequestDtoToJSON(json: any): UpdateVendorErrorCodeRequestDto {
    return UpdateVendorErrorCodeRequestDtoToJSONTyped(json, false);
}

export function UpdateVendorErrorCodeRequestDtoToJSONTyped(value?: UpdateVendorErrorCodeRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'manufacturerId': value['manufacturerId'],
        'assetTypeId': value['assetTypeId'],
        'errorCode': value['errorCode'],
        'matchType': value['matchType'],
        'matchKey': value['matchKey'],
        'vendorErrorCode': value['vendorErrorCode'],
        'info': value['info'],
        'parameter': VendorErrorParameterToJSON(value['parameter']),
        'state': VendorErrorStateToJSON(value['state']),
        'impactedComponent': VendorErrorImpactedComponentToJSON(value['impactedComponent']),
        'category': VendorErrorCategoryToJSON(value['category']),
        'severity': VendorErrorSeverityToJSON(value['severity']),
        'firmwareVersion': value['firmwareVersion'],
        'description': value['description'],
    };
}

